import { useEffect } from "react";

/**
 * Hook that invokes callback when clicked outside the ref
 */
export default function useClickOutsideElement(ref, callback) {
  useEffect(() => {
    /**
     * Invoke callback if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}
